<script setup lang="ts">
import { reactive, ref } from "vue";
import { useRouter } from "vue-router";
import { LockOutlined, MailOutlined } from "@ant-design/icons-vue";
import { message } from "ant-design-vue";
import { useAdminAuthStore } from "../stores/adminAuth";

const router = useRouter();
const adminAuth = useAdminAuthStore();
const loading = ref(false);
const form = reactive({
  email: "admin@autumnpet.local",
  password: ""
});

async function submit() {
  loading.value = true;
  try {
    await adminAuth.login(form.email, form.password);
    message.success("欢迎回来");
    await router.push("/admin/users");
  } catch (currentError) {
    message.error(currentError instanceof Error ? currentError.message : "登录失败，请稍后再试。");
  } finally {
    loading.value = false;
  }
}
</script>

<template>
  <main class="admin-login-page">
    <section class="admin-login-panel">
      <a-card class="admin-login-card">
        <div class="admin-login-card__brand">
          <img src="/brand-logo.png" alt="" aria-hidden="true" />
          <div>
            <strong>Autumn Pet</strong>
            <span>写实桌宠运营后台</span>
          </div>
        </div>
        <a-typography-title :level="3">管理员登录</a-typography-title>
        <a-form layout="vertical" :model="form" @finish="submit">
          <a-form-item label="邮箱地址" name="email" :rules="[{ required: true, message: '请输入管理员邮箱' }]">
            <a-input v-model:value="form.email" autocomplete="username" size="large">
              <template #prefix><MailOutlined /></template>
            </a-input>
          </a-form-item>
          <a-form-item label="密码" name="password" :rules="[{ required: true, message: '请输入管理员密码' }]">
            <a-input-password v-model:value="form.password" autocomplete="current-password" size="large">
              <template #prefix><LockOutlined /></template>
            </a-input-password>
          </a-form-item>
          <a-button block html-type="submit" size="large" type="primary" :loading="loading">
            进入后台
          </a-button>
        </a-form>
      </a-card>
    </section>
  </main>
</template>
